(function () {
  var context = window.avencoProductVideoAnalytics || {};
  var videoMedia = Array.isArray(context.media) ? context.media : [];

  if (!context.page_type && !context.product_id && !context.collection_handle) {
    return;
  }

  var sent = {};
  var progressMarks = [25, 50, 75, 100];
  var clickBound = false;
  var mutationBound = false;
  var iframeFocusBound = false;
  var visibilityObserver = null;
  var observedTargets = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var hoveredIframe = null;

  function findMediaById(mediaId) {
    if (!mediaId) return null;
    mediaId = String(mediaId);
    return videoMedia.find(function (media) {
      return String(media.media_id) === mediaId;
    }) || null;
  }

  function findMediaByIndex(index) {
    if (index === undefined || index === null || index === '') return null;
    var numericIndex = Number(index);
    return videoMedia.find(function (media) {
      return Number(media.media_index) === numericIndex;
    }) || null;
  }

  function getMediaFromElement(element) {
    if (!element) return null;

    var mediaIdElement = element.closest('[data-id], [data-media-id]');
    if (mediaIdElement) {
      var mediaById = findMediaById(mediaIdElement.getAttribute('data-id') || mediaIdElement.getAttribute('data-media-id'));
      if (mediaById) return mediaById;
    }

    var slide = element.closest('.product-main-slide, .product__thumb-item');
    if (slide) {
      var mediaByIndex = findMediaByIndex(slide.getAttribute('data-index'));
      if (mediaByIndex) return mediaByIndex;
    }

    return getEmbeddedMedia(element);
  }

  function parseVideoUrl(url) {
    if (!url) return null;

    try {
      var parsed = new URL(url, window.location.href);
      var host = parsed.hostname.replace(/^www\./, '');
      var id = '';

      if (host.indexOf('youtube.com') > -1) {
        var embedMatch = parsed.pathname.match(/\/embed\/([^/?]+)/);
        id = parsed.searchParams.get('v') || (embedMatch && embedMatch[1]) || '';
        return id ? { source: 'youtube', id: id } : null;
      }

      if (host.indexOf('youtu.be') > -1) {
        id = parsed.pathname.replace(/^\//, '').split('/')[0];
        return id ? { source: 'youtube', id: id } : null;
      }

      if (host.indexOf('vimeo.com') > -1) {
        id = parsed.pathname.split('/').filter(Boolean).pop() || '';
        return id ? { source: 'vimeo', id: id } : null;
      }
    } catch (error) {
      return null;
    }

    return null;
  }

  function getEmbeddedMedia(element) {
    var target = element.matches('iframe, video') ? element : element.querySelector('iframe[src*="youtube"], iframe[src*="vimeo"], video');
    if (!target) return null;

    var index = target.getAttribute('data-avenco-video-index') || '';
    var media = null;

    if (target.tagName.toLowerCase() === 'iframe') {
      media = parseVideoUrl(target.getAttribute('src'));
    } else {
      media = { source: 'html5', id: target.currentSrc || target.getAttribute('src') || index };
    }

    if (!media) return null;

    return {
      media_id: media.source + ':' + media.id,
      media_index: index === '' ? undefined : Number(index),
      media_type: target.tagName.toLowerCase() === 'video' ? 'video' : 'external_video',
      video_source: media.source
    };
  }

  function baseParams(media, extra) {
    media = media || {};
    return Object.assign({
      product_id: String(context.product_id),
      page_type: context.page_type || '',
      collection_handle: context.collection_handle || '',
      collection_title: context.collection_title || '',
      product_handle: context.product_handle || '',
      product_title: context.product_title || '',
      variant_id: context.variant_id ? String(context.variant_id) : '',
      send_to: context.ga4_measurement_id || undefined,
      media_id: media.media_id ? String(media.media_id) : '',
      media_type: media.media_type || '',
      video_source: media.video_source || '',
      video_position: media.media_index !== undefined ? Number(media.media_index) + 1 : undefined,
      page_location: window.location.href,
      page_title: document.title
    }, extra || {});
  }

  function publish(eventName, media, extra, options) {
    var params = baseParams(media, extra);
    var dedupeKey = eventName + ':' + params.media_id + ':' + (params.progress_percent || '');

    if (options && options.once && sent[dedupeKey]) {
      return;
    }
    sent[dedupeKey] = true;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, params));

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }

    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish('avenco:' + eventName, params);
    }
  }

  function isVideoThumb(anchor) {
    if (!anchor || !anchor.matches('.product__thumb')) return false;
    var media = getMediaFromElement(anchor);
    return !!media;
  }

  function observeVisibleElements() {
    var targets = Array.prototype.slice.call(document.querySelectorAll(
      '.product__thumb, .product-main-slide, .product__video, .product-video-trigger, iframe[src*="youtube"], iframe[src*="vimeo"], video'
    )).filter(function (element) {
      return !!getMediaFromElement(element) && (
        isVideoThumb(element) ||
        element.querySelector('.product__video, .product__video-wrapper, .product-video-trigger') ||
        element.matches('.product__video, .product-video-trigger, iframe, video')
      );
    });

    if (!targets.length || !('IntersectionObserver' in window)) {
      return;
    }

    if (!visibilityObserver) {
      visibilityObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
        var media = getMediaFromElement(entry.target);
        publish('product_video_visible', media, { visibility_ratio: Math.round(entry.intersectionRatio * 100) }, { once: true });
        visibilityObserver.unobserve(entry.target);
      });
      }, { threshold: [0.5] });
    }

    targets.forEach(function (target) {
      if (observedTargets && observedTargets.has(target)) return;
      if (observedTargets) observedTargets.add(target);
      visibilityObserver.observe(target);
    });
  }

  function bindClickEvents() {
    if (clickBound) return;
    clickBound = true;

    document.addEventListener('click', function (event) {
      var clicked = event.target.closest('.product__thumb, .product-video-trigger, .product__video, .product__video-wrapper');
      if (!clicked) return;

      var media = getMediaFromElement(clicked);
      if (!media) return;

      if (clicked.matches('.product__thumb') && !isVideoThumb(clicked)) {
        return;
      }

      publish('product_video_clicked', media, {
        click_target: clicked.className ? String(clicked.className).slice(0, 120) : clicked.tagName.toLowerCase()
      });
    }, true);
  }

  function bindNativeVideoEvents() {
    document.querySelectorAll('video.product__video, video.product-video-mp4-sound, .main-content video').forEach(function (video) {
      if (video.getAttribute('data-avenco-native-bound') === 'true') return;
      var media = getMediaFromElement(video);
      if (!media) return;
      video.setAttribute('data-avenco-native-bound', 'true');

      video.addEventListener('play', function () {
        publish('product_video_played', media, {}, { once: true });
      });

      video.addEventListener('ended', function () {
        publish('product_video_ended', media, {}, { once: true });
      });

      video.addEventListener('timeupdate', function () {
        if (!video.duration || !isFinite(video.duration)) return;

        var progress = Math.floor((video.currentTime / video.duration) * 100);
        progressMarks.forEach(function (mark) {
          if (progress >= mark) {
            publish('product_video_progress', media, { progress_percent: mark }, { once: true });
          }
        });
      });
    });
  }

  function prepareEmbeddedVideoIndexes() {
    document.querySelectorAll('.main-content iframe[src*="youtube"], .main-content iframe[src*="vimeo"], .main-content video, video.product__video, video.product-video-mp4-sound').forEach(function (element, index) {
      if (!element.hasAttribute('data-avenco-video-index')) {
        element.setAttribute('data-avenco-video-index', index);
      }
    });
  }

  function ensureYouTubeApi(callback) {
    if (window.YT && typeof window.YT.Player === 'function') {
      callback();
      return;
    }

    var previousReady = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof previousReady === 'function') {
        previousReady();
      }
      callback();
    };

    if (!document.getElementById('youtube-iframe-api')) {
      var script = document.createElement('script');
      script.id = 'youtube-iframe-api';
      script.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(script);
    }
  }

  function enableYouTubeJsApi(iframe) {
    try {
      var url = new URL(iframe.getAttribute('src'), window.location.href);
      if (url.hostname.indexOf('youtube') === -1 && url.hostname.indexOf('youtu.be') === -1) return;

      url.searchParams.set('enablejsapi', '1');
      url.searchParams.set('origin', window.location.origin);
      iframe.setAttribute('src', url.toString());

      if (!iframe.id) {
        iframe.id = 'avenco-youtube-video-' + iframe.getAttribute('data-avenco-video-index');
      }
    } catch (error) {}
  }

  function bindYouTubeEvents() {
    var iframes = Array.prototype.slice.call(document.querySelectorAll('.main-content iframe[src*="youtube"]'));
    if (!iframes.length) return;

    iframes.forEach(enableYouTubeJsApi);

    ensureYouTubeApi(function () {
      iframes.forEach(function (iframe) {
        var media = getMediaFromElement(iframe);
        if (!media || iframe.getAttribute('data-avenco-youtube-bound') === 'true') return;
        iframe.setAttribute('data-avenco-youtube-bound', 'true');

        try {
          new YT.Player(iframe.id, {
            events: {
              onStateChange: function (event) {
                if (event.data === YT.PlayerState.PLAYING) {
                  publish('product_video_played', media, {}, { once: true });
                }
                if (event.data === YT.PlayerState.ENDED) {
                  publish('product_video_ended', media, {}, { once: true });
                }
              }
            }
          });
        } catch (error) {}
      });
    });
  }

  function publishIframeClick(iframe) {
    var media = getMediaFromElement(iframe);
    if (!media) return;
    publish('product_video_clicked', media, { click_target: 'iframe' });
  }

  function bindIframeClickEvents() {
    document.querySelectorAll('.main-content iframe[src*="youtube"], .main-content iframe[src*="vimeo"]').forEach(function (iframe) {
      if (iframe.getAttribute('data-avenco-iframe-click-bound') === 'true') return;
      iframe.setAttribute('data-avenco-iframe-click-bound', 'true');

      iframe.addEventListener('mouseenter', function () {
        hoveredIframe = iframe;
      });

      iframe.addEventListener('mouseleave', function () {
        if (hoveredIframe === iframe) hoveredIframe = null;
      });

      iframe.addEventListener('focus', function () {
        publishIframeClick(iframe);
      }, true);
    });

    if (iframeFocusBound) return;
    iframeFocusBound = true;

    window.addEventListener('blur', function () {
      window.setTimeout(function () {
        var activeIframe = document.activeElement && document.activeElement.tagName === 'IFRAME'
          ? document.activeElement
          : hoveredIframe;

        if (activeIframe && activeIframe.matches('.main-content iframe[src*="youtube"], .main-content iframe[src*="vimeo"]')) {
          publishIframeClick(activeIframe);
        }
      }, 0);
    });
  }

  function rescan() {
    prepareEmbeddedVideoIndexes();
    observeVisibleElements();
    bindNativeVideoEvents();
    bindYouTubeEvents();
    bindIframeClickEvents();
  }

  function bindMutationRescan() {
    if (mutationBound || !('MutationObserver' in window)) return;
    mutationBound = true;

    var timeoutId = null;
    var root = document.querySelector('.main-content') || document.body;
    var observer = new MutationObserver(function () {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(rescan, 250);
    });

    observer.observe(root, { childList: true, subtree: true });
  }

  function init() {
    rescan();
    bindClickEvents();
    bindMutationRescan();
    window.setTimeout(rescan, 1000);
    window.setTimeout(rescan, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
